import uniq from 'lodash-es/uniq';
import {
    STROLLERS_WISHLIST_IDS_FETCH_SUCCESS,
    STROLLERS_WISHLIST_ITEMS_FETCH_FAILURE,
    STROLLERS_WISHLIST_ITEMS_FETCH_REQUEST,
    STROLLERS_WISHLIST_ITEMS_FETCH_SUCCESS,
    STROLLERS_WISHLIST_TOGGLE_SUCCESS,
    StrollersWishlistIdsFetchFailureAction,
    StrollersWishlistIdsFetchRequestAction,
    StrollersWishlistIdsFetchSuccessAction,
    StrollersWishlistItemsFetchFailureAction,
    StrollersWishlistItemsFetchRequestAction,
    StrollersWishlistItemsFetchSuccessAction,
    StrollersWishlistToggleSuccessAction,
} from 'mk2/apps/strollers/containers/WishList/WishList.actions';
import { initialStrollersWishListState } from 'mk2/apps/strollers/containers/WishList/WishList.constants';
import { tupdate } from 'mk2/helpers/types';
import { errorMessage, errorMessageFiltered } from 'mk2/reducers/errorMessage';
import { LoadingState, loadingState, loadingStateFiltered } from 'mk2/reducers/loadingState';
import { combineReducers, Reducer } from 'redux';

/**
 * Defaults to true till the server don't say other response
 *
 * @param state
 * @param action
 * @returns {boolean}
 */
const hasMore: Reducer<boolean> = (state: boolean = false, action: StrollersWishlistItemsFetchSuccessAction) => {
    switch (action.type) {
        case STROLLERS_WISHLIST_ITEMS_FETCH_SUCCESS:
            return action.hasMore;
        default:
            return state;
    }
};

export interface WishlistState {
    currentWishlist: string[];
    wishlistItemsIds: number[];
    loadingState: LoadingState;
    errorMessage: string;
    hasMore: boolean;
}

const wistListItemsReducer: Reducer<WishlistState> = combineReducers<WishlistState>({
    loadingState: loadingStateFiltered('STROLLERS_WISHLIST_ITEMS_FETCH'),
    errorMessage: errorMessageFiltered('STROLLERS_WISHLIST_ITEMS_FETCH'),
    wishlistItemsIds: (state = [], action) => {
        switch (action.type) {
            case STROLLERS_WISHLIST_ITEMS_FETCH_SUCCESS:
                return uniq([ ...state, ...action.response.result ]);
            default:
                return state;
        }
    },
    hasMore,
});

type WishlistFetchAction =
    StrollersWishlistIdsFetchRequestAction
    | StrollersWishlistIdsFetchSuccessAction
    | StrollersWishlistIdsFetchFailureAction
    | StrollersWishlistItemsFetchRequestAction
    | StrollersWishlistItemsFetchSuccessAction
    | StrollersWishlistItemsFetchFailureAction
    | StrollersWishlistToggleSuccessAction;

export const wishListReducer: Reducer<WishlistState> = (state = initialStrollersWishListState, action: WishlistFetchAction) => {
    let strollers;

    switch (action.type) {
        case STROLLERS_WISHLIST_IDS_FETCH_SUCCESS:
            strollers = uniq([ ...state.currentWishlist, ...action.response.result.wishlistIds ]);

            return tupdate(state, {
                currentWishlist: strollers,
            });

        case STROLLERS_WISHLIST_ITEMS_FETCH_REQUEST:
        case STROLLERS_WISHLIST_ITEMS_FETCH_FAILURE:
            return tupdate(state, {
                loadingState: loadingState(state.loadingState, action),
                errorMessage: errorMessage(state.errorMessage, action),
            });

        case STROLLERS_WISHLIST_ITEMS_FETCH_SUCCESS:
            return tupdate(state, {
                wishlistItemsIds: uniq([ ...state.wishlistItemsIds, ...action.response.result.strollers ]),
                loadingState: loadingState(state.loadingState, action),
                errorMessage: errorMessage(state.errorMessage, action),
                hasMore: action.hasMore,
            });

        case STROLLERS_WISHLIST_TOGGLE_SUCCESS:
            const id = action.id.toString();
            strollers = uniq([ ...state.currentWishlist ]);
            if (strollers.indexOf(id) > -1) {
                strollers.splice(strollers.indexOf(id), 1);
            } else {
                if (strollers.length === 0) {
                    strollers = [id];
                } else {
                    strollers.push(id);
                }
            }

            return tupdate(state, {
                currentWishlist: strollers,
            });

        default:
            return state;
    }
};

export default wishListReducer;
